import { useEffect } from 'react';
import styled from '@emotion/styled';

import { ScreenName } from '../../../../shared/amplitude';
import { useScreenName } from '../../../../shared/hooks';

import ReviewGallery from './ReviewGallery';
import ReviewList from './ReviewList';
import ReviewBenefitNotice from './ReviewBenefitNotice';
import useReviewInitData from '../hooks/useReviewInitData';
import ReviewHeader from './ReviewHeader';

const Section = styled.section`
  padding: 72px 0;
`;

interface Props {
  contentsProductNo: number;
}

export default function ProductReviewContainer({ contentsProductNo }: Props) {
  const { reviewCount } = useReviewInitData(contentsProductNo);

  useEffect(() => {
    document.addEventListener('contextmenu', (event: MouseEvent) => event.preventDefault());
  }, []);

  useScreenName(ScreenName.PRODUCT_DETAIL_DESCRIPTION);

  return (
    <Section>
      <ReviewHeader />
      <ReviewBenefitNotice />
      <ReviewGallery contentsProductNo={contentsProductNo} />
      <ReviewList contentsProductNo={contentsProductNo} count={reviewCount} />
    </Section>
  );
}
